// extracted by mini-css-extract-plugin
export default {"container":"MainMenu_container__q3DdD"};